import { CustomerState } from '../state';
import { appStorage, AppStorageKey } from '../../../../../helpers';

export const clearCustomerReducer = (state: CustomerState) => {
  appStorage.remove(AppStorageKey.CUSTOMER_STATE);
  appStorage.remove(AppStorageKey.AUTH_TOKEN);
  appStorage.remove(AppStorageKey.SSE_TOKEN);

  state.authedId = null;
  state.authedSSE = false;
  state.registered = false;
  state.customer = undefined;
  state.authedId = null;
  state.loggedIn = false;
  state.isSubscriber = false;
  state.isVerified = false;
  state.hasPrescription = false;
  state.hasTrialed = false;
  state.statusDoctorAuth = null;
  state.converted = false;
};
